export const getTestId = (testId: string) => {
  if (process.env.NODE_ENV === "production") {
    return null;
  }
  return testId.toLowerCase().replace(" ", "-");
};
